<template>
  <v-layout row wrap>
    <v-col cols :sm="12" class="pa-0">
      <v-card v-show="!Banner.isForm" flat class="pa-2 text-no-wrap">
        <v-data-table
          dense
          must-sort
          fixed-header
          item-key="id"
          :items="Banner.list"
          :options.sync="pagings"
          :headers="cTableHeaders"
          :server-items-length="Banner.total"
          :items-per-page="Banner.filter.limit"
          :footer-props="{ itemsPerPageOptions: Banner.itemPages }"
          :item-class="(e) => (id == e.id ? 'primary lighten-5' : '')"
        >
          <template v-slot:top>
            <v-layout px-2 justify-space-around align-end>
              <v-layout align-center>
                <h2>{{ $t("menu.banner") }}</h2>
                <v-btnc
                  :size="30"
                  icon="mdi-plus"
                  @click="
                    fnCallCreateView(model);
                    _fnLoadData();
                  "
                  v-if="fnCheckMission(Session, [{ m: BANNER, p: CREATE }])"
                />
              </v-layout>
              <v-spacer />
              <div class="mb-3" :style="{ width: '250px' }">
                <v-text-field
                  dense
                  single-line
                  hide-details
                  v-model="Banner.search"
                  @keydown.enter="_fnSearch"
                  :placeholder="$t(`table.search`)"
                />
              </div>
            </v-layout>
          </template>
          <template #[`item.createdAt`]="{ item }">
            <v-btnc
              color="warning"
              icon="mdi-pencil"
              @click="
                fnCallUpdateView({ model, item: item });
                _fnLoadData();
              "
              v-if="fnCheckMission(Session, [{ m: BANNER, p: UPDATE }])"
            />
            <v-btnc
              color="error"
              icon="mdi-delete"
              @click="fnCallDeleteView({ model, item: item })"
              v-if="fnCheckMission(Session, [{ m: BANNER, p: DELETE }])"
            />
          </template>
          <template #[`item._id`]="{ item }"> {{ item.id }}<br /> </template>
          <template #[`item.image`]="{ item }">
            <v-upload
              class="py-1"
              :size="30"
              v-model="item.image"
              :readonly="true"
            />
          </template>
          <template #[`item.expiryDate`]="{ item }">
            {{ item.expiryDate | mDate }}
          </template>
          <template #[`item.type`]="{ item }">
            {{ item.type.name }}
          </template>
          <template #[`item.status`]="{ item }">
            <span
              :class="
                item.status.id == '5fe95a72438161234fc20760'
                  ? 'success--text'
                  : 'error--text'
              "
            >
              {{ item.status.name }}
            </span>
          </template>
          <template #[`item.updatedBy`]="{ item }">
            {{ item.updatedBy.name }}
          </template>
          <template #[`item.updatedAt`]="{ item }">
            {{ item.updatedAt | mDateTime }}
          </template>
        </v-data-table>
      </v-card>
    </v-col>
    <v-col cols :sm="12" class="pa-0"><v-dialog /></v-col>
  </v-layout>
</template>

<script>
import Dialog from "./dialog.vue";

export default {
  components: {
    "v-dialog": Dialog,
  },
  data() {
    return {
      id: "",
      model: "Banner",
      pagings: {},
    };
  },
  computed: {
    cTableHeaders() {
      let table = [
        {
          text: this.$t(`table.action`),
          sortable: false,
          value: "createdAt",
          width: "10px",
        },
        {
          text: this.$t(`table.id`),
          value: "_id",
          width: "10px",
        },
        {
          text: this.$t(`table.image`),
          value: "image",
          width: "10px",
        },
        {
          text: this.$t(`table.title`),
          value: `title${this.$i18n.locale.toUpperCase()}`,
        },
        {
          text: this.$t(`table.expiryDate`),
          value: "expiryDate",
          width: "10px",
        },
        {
          text: this.$t(`table.type`),
          value: "type",
          width: "10px",
        },
        {
          text: this.$t(`table.priority`),
          value: "priority",
          width: "10px",
        },
        {
          text: this.$t(`table.status`),
          value: "status",
          width: "10px",
        },
        {
          text: this.$t(`table.updatedBy`),
          value: "updatedBy",
          width: "10px",
        },
        {
          text: this.$t(`table.updatedAt`),
          value: "updatedAt",
          width: "10px",
        },
      ];
      return table;
    },
  },
  watch: {
    "Banner.isRefresh": function (val) {
      if (val) {
        this._fnCallListView();
      }
    },
    pagings: function (val) {
      const { itemsPerPage, page, sortBy, sortDesc } = val;
      this[this.model].filter.limit = itemsPerPage;
      this[this.model].filter.page = page;
      if (sortBy.length) {
        this[this.model].filter.sort = `${sortBy[0]}:${sortDesc[0] ? -1 : 1}`;
      }
      this._fnCallListView();
    },
  },
  methods: {
    _fnLoadData() {
      if (this[this.model].isCreate) {
        this[this.model].obj = { priority: 1 };
      } else if (this[this.model].isUpdate) {
        this.id = this[this.model].obj.id;
        this[this.model].obj = {
          ...this[this.model].obj,
          type: this[this.model].obj.type.id,
          status: this[this.model].obj.status.id,
        };
      }
    },
    _fnCallListView() {
      this.fnCallListView({
        url: "/v1/admin/banner",
        model: this.model,
      });
    },
    _fnSearch({ target: { value } }) {
      if (!value) delete this[this.model].filter.$text;
      else this[this.model].filter.$text = value;
      this._fnCallListView();
    },
    _fnBuild(roles) {
      let str = "";
      roles.forEach((role) => {
        str += `- ${role.name} <br/>`;
      });
      return str;
    },
  },
};
</script>
